/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Discordlinked_Footer1Inputs */

const id_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda sekarang dapat menutup jendela ini dan kembali ke Discord. Akun Anda siap digunakan dengan egdata.app`)
};

const ms_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda kini boleh tutup tetingkap ini dan kembali ke Discord. Akaun anda sedia untuk digunakan dengan egdata.app`)
};

const da_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan nu lukke dette vindue og vende tilbage til Discord. Din konto er klar til brug med egdata.app`)
};

const de_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie können dieses Fenster jetzt schließen und zu Discord zurückkehren. Ihr Konto ist bereit für die Nutzung mit egdata.app`)
};

const en_us2_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can now close this window and return to Discord. Your account is ready to use with egdata.app`)
};

const es_es2_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya puedes cerrar esta ventana y volver a Discord. Tu cuenta está lista para usarse con egdata.app`)
};

const es_mx2_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya puedes cerrar esta ventana y volver a Discord. Tu cuenta está lista para usarse con egdata.app`)
};

const fil_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maaari mo na ngayong isara ang window na ito at bumalik sa Discord. Ang iyong account ay handa nang gamitin sa egdata.app`)
};

const fr_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez maintenant fermer cette fenêtre et retourner sur Discord. Votre compte est prêt à être utilisé avec egdata.app`)
};

const it_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ora puoi chiudere questa finestra e tornare su Discord. Il tuo account è pronto per essere utilizzato con egdata.app`)
};

const hu_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most bezárhatod ezt az ablakot, és visszatérhetsz a Discordhoz. Fiókod készen áll az egdata.app-pal való használatra.`)
};

const nl_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je kunt dit venster nu sluiten en terugkeren naar Discord. Je account is klaar voor gebruik met egdata.app`)
};

const no_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan nå lukke dette vinduet og gå tilbake til Discord. Kontoen din er klar til bruk med egdata.app`)
};

const pl_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Możesz teraz zamknąć to okno i wrócić do Discorda. Twoje konto jest gotowe do użycia z egdata.app`)
};

const pt_br2_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora você pode fechar esta janela e retornar para Discord. Sua conta está pronta para uso com egdata.app`)
};

const pt_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pode agora fechar esta janela e voltar ao Discord. A sua conta está pronta para usar com o egdata.app`)
};

const ro_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poți închide acum această fereastră și reveni la Discord. Contul tău este gata de utilizare cu egdata.app`)
};

const fi_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voit nyt sulkea tämän ikkunan ja palata Discordiin. Tilisi on valmis käytettäväksi egdata.appin kanssa`)
};

const sv_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan nu stänga detta fönster och återgå till Discord. Ditt konto är redo att användas med egdata.app`)
};

const vi_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn có thể đóng cửa sổ này và quay lại Discord. Tài khoản của bạn đã sẵn sàng để sử dụng với egdata.app`)
};

const tr_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artık bu pencereyi kapatabilir ve Discord'a dönebilirsiniz. Hesabınız egdata.app ile kullanıma hazır.`)
};

const cs_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyní můžete zavřít toto okno a vrátit se do Discordu. Váš účet je připraven k použití s egdata.app`)
};

const bg_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вече можете да затворите този прозорец и да се върнете в Discord. Вашият акаунт е готов за използване с egdata.app`)
};

const ru_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теперь вы можете закрыть это окно и вернуться в Discord. Ваша учётная запись готова к использованию с egdata.app`)
};

const uk_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тепер ви можете закрити це вікно та повернутися до Discord. Ваш обліковий запис готовий до використання з egdata.app`)
};

const ar_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يمكنك الآن إغلاق هذه النافذة والعودة إلى Discord. حسابك جاهز للاستخدام مع egdata.app`)
};

const hi_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अब आप इस विंडो को बंद कर सकते हैं।`)
};

const th_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณสามารถปิดหน้าต่างนี้และกลับไปที่ Discord บัญชีของคุณพร้อมใช้งานกับ egdata.app`)
};

const ja_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このウィンドウを閉じて Discord に戻れます。アカウントは egdata.app で使用する準備ができています`)
};

const zh_cn2_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`现在可以关闭此窗口并返回 Discord。你的账号已可用于 egdata.app`)
};

const zh_hant1_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在可以關閉此視窗並返回 Discord。你的帳號已可用於 egdata.app`)
};

const ko_misc_discordlinked_footer1 = /** @type {(inputs: Misc_Discordlinked_Footer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이제 이 창을 닫고 Discord로 돌아가면 됩니다. 계정을 egdata.app과 함께 사용할 준비가 되었습니다.`)
};

/**
* | output |
* | --- |
* | "You can now close this window and return to Discord. Your account is ready to use with egdata.app" |
*
* @param {Misc_Discordlinked_Footer1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_discordlinked_footer1 = /** @type {((inputs?: Misc_Discordlinked_Footer1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Discordlinked_Footer1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_discordlinked_footer1(inputs)
	if (locale === "ms") return ms_misc_discordlinked_footer1(inputs)
	if (locale === "da") return da_misc_discordlinked_footer1(inputs)
	if (locale === "de") return de_misc_discordlinked_footer1(inputs)
	if (locale === "en-US") return en_us2_misc_discordlinked_footer1(inputs)
	if (locale === "es-ES") return es_es2_misc_discordlinked_footer1(inputs)
	if (locale === "es-MX") return es_mx2_misc_discordlinked_footer1(inputs)
	if (locale === "fil") return fil_misc_discordlinked_footer1(inputs)
	if (locale === "fr") return fr_misc_discordlinked_footer1(inputs)
	if (locale === "it") return it_misc_discordlinked_footer1(inputs)
	if (locale === "hu") return hu_misc_discordlinked_footer1(inputs)
	if (locale === "nl") return nl_misc_discordlinked_footer1(inputs)
	if (locale === "no") return no_misc_discordlinked_footer1(inputs)
	if (locale === "pl") return pl_misc_discordlinked_footer1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_discordlinked_footer1(inputs)
	if (locale === "pt") return pt_misc_discordlinked_footer1(inputs)
	if (locale === "ro") return ro_misc_discordlinked_footer1(inputs)
	if (locale === "fi") return fi_misc_discordlinked_footer1(inputs)
	if (locale === "sv") return sv_misc_discordlinked_footer1(inputs)
	if (locale === "vi") return vi_misc_discordlinked_footer1(inputs)
	if (locale === "tr") return tr_misc_discordlinked_footer1(inputs)
	if (locale === "cs") return cs_misc_discordlinked_footer1(inputs)
	if (locale === "bg") return bg_misc_discordlinked_footer1(inputs)
	if (locale === "ru") return ru_misc_discordlinked_footer1(inputs)
	if (locale === "uk") return uk_misc_discordlinked_footer1(inputs)
	if (locale === "ar") return ar_misc_discordlinked_footer1(inputs)
	if (locale === "hi") return hi_misc_discordlinked_footer1(inputs)
	if (locale === "th") return th_misc_discordlinked_footer1(inputs)
	if (locale === "ja") return ja_misc_discordlinked_footer1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_discordlinked_footer1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_discordlinked_footer1(inputs)
	return ko_misc_discordlinked_footer1(inputs)
});
export { misc_discordlinked_footer1 as "misc.discordLinked.footer" }